import { Component } from '@rhtml/component';
import { css, html, LitElement, property } from '@rxdi/lit-html';
import Droppable from 'droppable';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/operators';

/**
 * @customElement file-uploader
 */
@Component<File[], [], FileUploaderComponent>({
  Settings: {
    selector: 'file-uploader',
    styles: [
      css`
        :host {
          outline: none;
          user-select: none;
        }
      `,
    ],
  },
  State: function (this) {
    return this.onFilesDropped().pipe(startWith([]));
  },
  Render: () =>
    function (this) {
      return html`<slot></slot>`;
    },
})
export class FileUploaderComponent extends LitElement {
  private droppable: Droppable;

  @property({ type: Boolean })
  isClickable: boolean;

  @property({ type: Boolean })
  acceptsMultipleFiles = true;

  OnUpdateFirst() {
    this.droppable = new Droppable({
      element: this,
      acceptsMultipleFiles: this.acceptsMultipleFiles,
      isClickable: this.isClickable,
    });
  }

  private onFilesDropped() {
    return new Observable<File[]>((observer) => {
      const listener = this.droppable.onFilesDropped((detail) => {
        this.dispatchEvent(new CustomEvent('filesDropped', { detail }));
        observer.next(detail);
      });

      return () => {
        observer.complete();
        listener();
      };
    });
  }

  OnDestroy() {
    this.droppable.destroy();
  }
}
